.root {
  display: block;
  margin-block: 0.25lh;
  height: 0.75lh;
  border-radius: 0.375rem;
  background: hsl(var(--muted));
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}
